<template>
  <el-container class="layout">
    <el-aside class="layout-nav">
      <el-menu router :collapse="isCollapse" :default-active="activeIndex">
        <div class="logo">运营系统</div>
        <div class="layout-nav-menu">
          <template v-for="menu of menus">
            <el-submenu v-if="menu.meta.submenu" :key="menu.path" :index="menu.meta.menuIndex">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span>{{ menu.meta.name }}</span>
              </template>
              <template v-for="c of menu.children">
                <el-submenu :key="c.path" v-if="c.meta.submenu" :index="c.meta.menuIndex">
                  <template slot="title">{{ c.meta.name }}</template>
                  <el-menu-item
                    v-for="cc of c.children"
                    :key="cc.path"
                    :index="cc.meta.menuIndex"
                    :route="{ name: cc.name }"
                  >
                    {{ cc.meta.name }}
                  </el-menu-item>
                </el-submenu>

                <el-menu-item
                  :key="c.path"
                  v-else
                  :index="c.meta.menuIndex"
                  :route="{ name: c.name || c.meta.menuIndex }"
                  >{{ c.meta.name }}
                </el-menu-item>
              </template>
            </el-submenu>

            <el-menu-item
              v-else
              :key="menu.path"
              :index="menu.meta.menuIndex"
              :route="{ name: menu.meta.menuIndex }"
            >
              <i class="el-icon-menu"></i>
              <span slot="title">{{ menu.meta.name }}</span>
            </el-menu-item>
          </template>
        </div>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="layout-header">
        <div class="collapse">
          <el-checkbox v-model="isCollapse"></el-checkbox>
        </div>
        <comp-header />
      </el-header>
      <el-main class="layout-section">
        <el-breadcrumb v-show="breadcrumb.length" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            v-for="item of breadcrumb"
            :key="item.path"
            :to="item.submenu ? '' : { path: item.path }"
            >{{ item.name }}
          </el-breadcrumb-item>
        </el-breadcrumb>
        <router-view class="layout-content" />

        <form-download />
      </el-main>
    </el-container>
    <div class="googleModal" v-show="showGoogleModal">
      <div class="googleContent">
        <div class="googleTitle">请绑定谷歌验证码</div>
        <div class="googleWrap">
          <img :src="googleInfo.qrCode" alt="二维码" />
          <p>谷歌密钥：{{ googleInfo.secret }}</p>
          <div class="inputGroup">
            <p class="tips">请输入谷歌验证码：</p>
            <el-input maxlength="6" placeholder="请输入6位数谷歌验证码" v-model="googleCode">
            </el-input>
          </div>
        </div>
        <div class="googleFooter">
          <el-button size="small" @click="cancelFun">取消</el-button>
          <el-button size="small" type="primary" @click="submitFunc">确认</el-button>
        </div>
      </div>
    </div>
  </el-container>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import CompHeader from './header';
import FormDownload from 'components/formDownload';

export default {
  name: 'home',
  components: {
    CompHeader,
    FormDownload,
  },
  data() {
    return {
      isCollapse: false,
      activeIndex: '',
      showGoogleModal: false,
      googleInfo: {},
      googleCode: '',
    };
  },
  created() {
    this.activeIndex = this.$route.meta.menuIndex;
    this.getBindStatusFun();
  },
  computed: {
    ...mapState('login', ['menus']),
    breadcrumb() {
      return this.$route.matched
        .map((val) => ({
          path: val.path,
          name: val.meta.name,
          submenu: val.meta.submenu,
        }))
        .filter((val) => !!val.name);
    },
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.meta.menuIndex;
    },
  },
  methods: {
    ...mapActions('login', ['logout']),
    ...mapActions('home', ['getGoogleCode']),
    ...mapActions('home', ['getBindStatus']),
    ...mapActions('home', ['bindGoogleCode']),

    getBindStatusFun() {
      this.getBindStatus({
        userId: Number(localStorage.userId),
      }).then((res) => {
        if (!res.data.googleSecret) {
          this.getGoogleCode().then((res) => {
            if (res.code === 0) {
              this.googleInfo = res.data;
              this.showGoogleModal = true;
            }
          });
        }
      });
    },
    cancelFun() {
      this.logout();
    },
    submitFunc() {
      if (this.googleCode) {
        this.bindGoogleCode({ code: Number(this.googleCode), secret: this.googleInfo.secret }).then(
          () => {
            this.showGoogleModal = false;
            this.$message.success('绑定成功');
          },
        );
      } else {
        this.$message.error('请输入谷歌验证码！');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$color: #fff;
$min-height: 560px;
.collapse {
  position: relative;
  z-index: 1;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 1px;
    width: 14px;
    height: 50px;
    background-color: darken($theme-color, 35%);
    border-radius: 0 10px 10px 0;
    cursor: pointer;
  }

  :global(.el-checkbox) {
    position: absolute;
    top: 3px;
    width: 14px;
    height: 50px;
  }
}

.layout {
  height: 100vh;
  background-color: $bg-color;
  @media (max-width: $body-min-width) {
    overflow-x: auto;
  }

  &-header {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 50px !important;
    padding: 0;
    background-color: $color;
    box-shadow: $shadow;
    display: flex;
    .header {
      flex: 1;
    }
  }

  &-nav {
    position: relative;
    z-index: 3;
    overflow-x: hidden;
    width: auto !important;
    background-color: $color;
    box-shadow: $shadow;

    &-menu {
      overflow-x: hidden;
      @extend %scrollbar;
      @extend %scrollbar-hide;
      height: calc(100vh - 50px);
    }
    .iconfont {
      font-size: 22px;
      color: $theme-color;
    }
  }

  &-section {
    position: relative;
    overflow: hidden;
    height: calc(100vh - 50px);
    padding: 0;
    background: url('~images/logo.png') no-repeat center;
  }
  :global(.el-breadcrumb) {
    height: 50px;
    line-height: 50px !important;
    padding: 0 20px;
    font-size: 16px;
    background-color: #fff;
    border-bottom: 1px solid $theme-color;
  }
  &-content {
    position: relative;
    display: flex;
    flex-flow: column;
    height: calc(100% - 50px);
    //min-height: $min-height - 50px - 50px;
    padding: 20px;
    background-color: #fff;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: rgba(#000, 0.5);
    }
  }
}

.logo {
  height: 50px;
  line-height: 50px;
  padding-left: 64px;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  background: $theme-color url('~images/logo.png') no-repeat 8px center;
  background-size: 50px auto;
}
// :global(.googleContent) {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
// }
// :global(.googleInput) {
//   width: 100px;
//   height: 30px;
// }
.googleModal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2001;
  display: flex;
  align-items: center;
  justify-content: center;
  .googleContent {
    width: 500px;
    background: #fff;
    border-radius: 5px;
    padding: 10px 30px;
    .googleTitle {
      font-size: 18px;
      font-weight: 500;
      text-align: center;
    }
    .googleWrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .inputGroup {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5px;
        .tips {
          font-size: 14px;
          white-space: nowrap;
        }
        :global(.el-input__inner) {
          width: 200px;
          height: 30px !important;
        }
      }
    }
    .googleFooter {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 20px;
    }
  }
}
</style>
